import React, { useState } from "react";
import { Link } from "react-router-dom";
import { formatUAH } from "../lib/format";

export const ProductCard = ({ product }) => {
  const [hover, setHover] = useState(false);

  // Coming soon — non-clickable placeholder, no image, no price
  if (product.coming_soon) {
    return (
      <div
        className="group block cursor-default select-none"
        data-testid={`product-card-${product.slug}`}
        aria-disabled="true"
      >
        <div className="relative aspect-[3/4] overflow-hidden bg-silea-navy flex items-center justify-center">
          <div className="text-center px-6">
            <p className="font-serif-display italic text-3xl sm:text-4xl text-silea-yellow leading-none">
              Coming
            </p>
            <p className="font-serif-display italic text-3xl sm:text-4xl text-white/90 leading-none mt-1">
              soon
            </p>
          </div>
          <div className="absolute top-3 left-3 bg-white/10 backdrop-blur px-2 py-1 eyebrow text-white/70">
            {product.category === "bikini" ? "Бікіні" : "Суцільний"}
          </div>
        </div>
        <div className="mt-4 flex items-start justify-between gap-3">
          <div>
            <h3 className="font-serif-display text-xl text-silea-navy/70 leading-tight">{product.name_short}</h3>
            <p className="text-xs text-silea-navy/40 mt-1">Незабаром у колекції</p>
          </div>
          <p className="eyebrow text-silea-navy/40 whitespace-nowrap">Soon</p>
        </div>
      </div>
    );
  }

  const second = product.images[1] || product.images[0];

  return (
    <Link
      to={`/products/${product.slug}`}
      className="group block"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      data-testid={`product-card-${product.slug}`}
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-stone-100">
        <img
          src={hover ? second : product.images[0]}
          alt={product.name}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
        />
        <div className="absolute top-3 left-3 bg-silea-cream/90 backdrop-blur px-2 py-1 eyebrow text-silea-navy/70">
          {product.category === "bikini" ? "Бікіні" : "Суцільний"}
        </div>
      </div>
      <div className="mt-4 flex items-start justify-between gap-3">
        <div>
          <h3 className="font-serif-display text-xl text-silea-navy leading-tight">{product.name_short}</h3>
          <p className="text-xs text-silea-navy/60 mt-1">{product.short_description}</p>
        </div>
        <p className="text-silea-navy font-medium whitespace-nowrap">{formatUAH(product.price)}</p>
      </div>
    </Link>
  );
};
